import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/auth';
import { updatePersonalInfo } from './utils';

export default function* listenUpdatePersonalInfo() {
  yield takeEvery(actionTypes.setPersonalInfo.toString(), updatePersonalInfo);
}
